<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '配件型号'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    :close-on-click-modal="false">
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="配件型号名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="配件型号" prop="Number">
        <el-input v-model.trim="item.Number" placeholder="请输入型号"></el-input>
      </el-form-item>
      <el-form-item label="配件SN代码" prop="SNCode">
        <el-input v-model.trim="item.SNCode" placeholder="请输入SN代码"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="Remark">
        <el-input v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入说明">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting || !item.Name">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
        ],
        Number: [
          { required: true, message: '型号不能为空', trigger: 'blur' },
        ],
        SNCode: [
          { required: true, message: 'SN不能为空', trigger: 'blur' },
        ],
        Remark: [
          { max: 64000, message: '内容过多', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios.request({
          url: 'dci/model/accessory',
          method: 'post',
          data: itemData,
        }).then(() => {
          this.$message.success('新增成功');
          this.submitting = false;
          this.$emit('form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit('form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
